module.exports = __webpack_public_path__ + "static/media/remove_fromtrip_ic.c9050601.svg";